import { useEffect, useState } from 'react';
import { Avatar, Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { UploadedSuccessfully } from 'Images';

const HIDE_AFTER_MS = 6000;

export const UploadedSuccessful = () => {
  const dictionary = useDictionary(Dictionary, DICTIONARY.UniversalRequest);
  const isDesktop = useIsDesktop();
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(false), HIDE_AFTER_MS);
    return () => clearTimeout(timer);
  }, []);

  return (
    <Stack
      sx={{
        flexDirection: 'row',
        gap: '4px',
        p: '4px',
        bgcolor: '#E0F6EF',
        borderRadius: '20px',
        width: 'fit-content',
        alignItems: 'center',
        mt: isDesktop ? undefined : '-20px',
        ml: isDesktop ? undefined : '40px',
        display: isVisible ? undefined : 'none',
      }}
    >
      <Avatar
        src={UploadedSuccessfully}
        alt={''}
        sx={{ width: '24px', height: '24px' }}
      />
      <Typography variant='body8' color='#344266' width='fit-content' pr='8px'>
        {dictionary.uploadFile.uploadedSuccessfully}
      </Typography>
    </Stack>
  );
};
